<section class="playground">
  <h2 class="playground__heading">Tabs</h2>
  <p class="playground__hint">
    <code>app-tabs</code> — envoltorio sobre <code>mat-tab-group</code> con anatomía Munily (48px / 180px, estados y badges).
  </p>

  <div class="playground__block">
    <p class="playground__preview-title">Pestañas con contadores</p>
    <label class="playground__field playground__field--inline">
      <input type="checkbox" [(ngModel)]="showBadge" />
      <span>showBadge</span>
    </label>
    <app-tabs
      [tabs]="tabsWithBadges"
      [showBadge]="showBadge"
      [(selectedIndex)]="selectedIndex"
      (tabChanged)="onTabChanged($event)"
    ></app-tabs>
    <p class="playground__meta">selectedIndex: {{ selectedIndex }} · {{ lastEvent }}</p>
  </div>

  <div class="playground__block">
    <p class="playground__preview-title">Sin badges</p>
    <app-tabs [tabs]="tabsPlain" [showBadge]="false" [selectedIndex]="0"></app-tabs>
  </div>
</section>
